import { all } from 'redux-saga/effects';

import alteraPrefeiturasServicosCanaisSaga from './alteraPrefeiturasServicosCanais/saga';
import consultaPrefeiturasServicosCanaisSaga from './consultaPrefeiturasServicosCanais/saga';

export default all([
	alteraPrefeiturasServicosCanaisSaga,
	consultaPrefeiturasServicosCanaisSaga,
]);
